import React from 'react'
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic'
import FlexView from 'react-flexview/lib'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import DataLayerService from '../../services/DataLayerService'

export const RequesetSupportTag = ({ icon, text, tag }) => {
  const onTagClick = () =>
    DataLayerService.pushToDataLayer({
      event: 'contact-us-tag-clicked',
      target: tag,
    })

  return (
    <FlexView vAlignContent={'center'}>
      {icon || <HeadsetMicIcon className="gray margin-right-6" />}
      <div className="text-small gray">
        {text} please{' '}
        <a
          onClick={onTagClick}
          target="_blank"
          className="blue"
          href={FirebaseService.getValue(FirebaseConfigKey.CONTACT_US_URL)}>
          contact us
        </a>
      </div>
    </FlexView>
  )
}
